import React, { Fragment, useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import TextField from "@material-ui/core/TextField";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
  auth,
  provider_fb,
  provider_google,
  // provider_apple, // Available but not currently used
} from "../Firebase";
import { addUser } from "../../store/actions/action";
import NewNavbar from '../../new-components/NewNavbar'
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from '../../new-components/NewOverrides'
import NewDesignSystem from '../../new-components/NewDesignSystem'
import NewFooter from '../../new-components/NewFooter'
import NewMadeWith from '../../new-components/NewMadeWith'
import NewScrollTop from '../../new-components/NewScrollTop'

import "./style_new.scss";

const LoginPage = (props) => {
  let history = useHistory();

  const [value, setValue] = useState({
    email: "",
    password: "",
    remember: false,
  });

  const [submitAttempted, setSubmitAttempted] = useState(false);

  // Load saved credentials on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const savedEmail = localStorage.getItem('rememberedEmail');
    const savedPassword = localStorage.getItem('rememberedPassword');
    const shouldRemember = localStorage.getItem('shouldRemember') === 'true';
    
    if (shouldRemember && savedEmail && savedPassword) {
      setValue({
        email: savedEmail,
        password: savedPassword,
        remember: true,
      });
    }
  }, []);

  const changeHandler = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
    // Only show validation messages if user has already attempted to submit
    if (submitAttempted) {
      validator.showMessages();
    }
  };

  const rememberHandler = () => {
    const newRememberValue = !value.remember;
    setValue({ ...value, remember: newRememberValue });
    
    // If unchecking remember, clear saved credentials
    if (!newRememberValue) {
      localStorage.removeItem('rememberedEmail');
      localStorage.removeItem('rememberedPassword');
      localStorage.removeItem('shouldRemember');
    }
  };

  const [validator] = React.useState(
    new SimpleReactValidator({
      className: "errorMessage",
      messages: {
        required: "Acest câmp este obligatoriu",
        email: "Te rugăm să introduci un e-mail valid",
      },
    })
  );

  const handle_facebook_login = (e) => {
    e.preventDefault();
    auth
      .signInWithPopup(provider_fb)
      .then((result) => {
        props.addUser(result.additionalUserInfo.profile);
        history.push("/");
      })
      .catch((error) => toast.error(error.message));
  };

  const handle_google_login = (e) => {
    e.preventDefault();

    auth
      .signInWithPopup(provider_google)
      .then((result) => {
        props.addUser(result.user);
        history.push("/home");
      })
      .catch((error) => toast.error(error.message));
  };

  // Note: Apple login functionality available but not currently used in UI
  // const handle_apple_login = (e) => {
  //   e.preventDefault();
  //   auth
  //     .signInWithPopup(provider_apple)
  //     .then((result) => {
  //       toast.success("You successfully Login on iSerenify!");
  //       history.push("/home");
  //     })
  //     .catch((error) => toast.error(error.message));
  // };

  const submitForm = (e) => {
    e.preventDefault();
    setSubmitAttempted(true);
    
    // Validate required fields manually
    const requiredFields = ['email', 'password'];
    const missingFields = requiredFields.filter(field => !value[field]);
    
    if (missingFields.length > 0) {
      const fieldNames = missingFields.map(field => {
        switch(field) {
          case 'email': return 'Email';
          case 'password': return 'Parolă';
          default: return field;
        }
      });
      toast.error(`Următoarele câmpuri sunt obligatorii: ${fieldNames.join(', ')}`);
      return;
    }
    
    const isEmailValid = /\S+@\S+\.\S+/.test(value.email);
    if (!isEmailValid) {
      toast.error("Te rugăm să introduci un email valid.");
      return;
    }
    
    // Save credentials if remember is checked
    if (value.remember) {
      localStorage.setItem('rememberedEmail', value.email);
      localStorage.setItem('rememberedPassword', value.password);
      localStorage.setItem('shouldRemember', 'true');
    } else {
      localStorage.removeItem('rememberedEmail');
      localStorage.removeItem('rememberedPassword');
      localStorage.removeItem('shouldRemember');
    }

    const email = value.email;
    auth
      .signInWithEmailAndPassword(email, value.password)
      .then((auth) => {
        props.addUser(auth.user.multiFactor.user);
        // toast.success("Logare reușită! Bine ai revenit!");
        
        // Clear form after successful login
        setValue({
          email: "",
          password: "",
          remember: false,
        });
        setSubmitAttempted(false);
        
        history.push("/home");
      })
      .catch((e) => {
        console.error("Login error:", e);
        toast.error("Email sau parolă incorectă. Te rugăm să încerci din nou.");
      });
  };

  // useEffect(() => {
  //   console.log(props.user);
  // }, [props.user]); // Only re-subscribe if props.friend.id changes

  return (
    <Fragment>
      <NewNavbar/>
      <NewOverrides/>
      <NewDesignSystem/>

      <NewPageHeader />
      <div className="signup-wrapper">
        <div className="signup-container">
          <div className="signup-glass-card">
            <div className="signup-header">
            <h2>Autentificare</h2>
            <p>Conectează-te la contul tău</p>
          </div>

          <form onSubmit={submitForm} className="signup-form">
            <div className="form-section">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    className="glass-input"
                    fullWidth
                    placeholder="E-mail"
                    value={value.email}
                    variant="outlined"
                    name="email"
                    label="E-mail"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onBlur={(e) => changeHandler(e)}
                    onChange={(e) => changeHandler(e)}
                    error={submitAttempted && (!value.email || !/\S+@\S+\.\S+/.test(value.email))}
                    helperText={submitAttempted && !value.email 
                      ? "Acest câmp este obligatoriu" 
                      : submitAttempted && !/\S+@\S+\.\S+/.test(value.email) 
                        ? "Te rugăm să introduci un email valid" 
                        : ""}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    className="glass-input"
                    fullWidth
                    placeholder="Parola"
                    value={value.password}
                    variant="outlined"
                    name="password"
                    type="password"
                    label="Parola"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onBlur={(e) => changeHandler(e)}
                    onChange={(e) => changeHandler(e)}
                    error={submitAttempted && !value.password}
                    helperText={submitAttempted && !value.password ? "Acest câmp este obligatoriu" : ""}
                  />
                </Grid>
              </Grid>
            </div>

            <div className="custom-checkbox">
              <input
                type="checkbox"
                id="remember"
                name="remember"
                checked={value.remember}
                onChange={rememberHandler}
                className="hidden-checkbox"
              />
              <label 
                htmlFor="remember" 
                className={`checkbox-label ${value.remember ? 'checked' : ''}`}
              >
                Memorează
              </label>
            </div>

            <button type="submit" className="signup-btn">
              Logare
            </button>

            <div className="social-login">
              <div className="divider">
                <span>sau</span>
              </div>
              <div className="social-buttons">
                <button type="button" className="social-btn facebook" onClick={handle_facebook_login}>
                  <i className="fa fa-facebook"></i>
                  Facebook
                </button>
                <button type="button" className="social-btn google" onClick={handle_google_login}>
                  <i className="fa fa-google"></i>
                  Google
                </button>
              </div>
            </div>

            <div className="signup-footer">
              <p>
                Nu ai un cont?{" "}
                <Link to="/register">
                  Creează unul gratuit
                </Link>
              </p>
            </div>
          </form>
          
          <div className="back-to-home">
            <Link to="/" className="back-to-home-btn">
              Înapoi la Pagina Principală
            </Link>
          </div>
        </div>
      </div>
    </div>
      <NewFooter/>
      <NewMadeWith/>
      <NewScrollTop/>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    loggedIn: state.user.loggedIn,
  };
};
export default connect(mapStateToProps, { addUser })(LoginPage);